import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'

import { InsufficientCreditsDialog } from '../InsufficientCreditsDialog/InsufficientCreditsDialog'

interface ProductCardProps {
  badge?: string
  title: string
  description: string
  credits: number
  turnaround: string
  buttonLabel: string
  onClick: () => void
}

export const ProductCard = ({
  badge,
  title,
  description,
  credits,
  turnaround,
  buttonLabel,
  onClick,
}: ProductCardProps) => {
  const { t } = useTranslation()
  const [openInsufficient, setOpenInsufficient] = useState(false)

  const hasCredits = credits > 0

  const handleClick = () => {
    if (hasCredits) {
      onClick()
    } else {
      setOpenInsufficient(true)
    }
  }

  return (
    <>
      <div className="flex flex-1 flex-col overflow-hidden rounded-3xl bg-baseColorHighlight">
        <div className="flex flex-col gap-1 p-5">
          {badge && (
            <p className="text-xs font-medium text-neutralColor60">{badge}</p>
          )}
          <p className="text-xl font-medium text-neutralColor">{title}</p>
          <p className="text-base text-neutralColor80">{description}</p>
        </div>

        <div className="mt-auto flex items-center justify-between gap-4 border-t border-neutralColor5 p-5">
          <div className="flex flex-col gap-1">
            <p className="text-sm text-neutralColor60">
              {t('dashboard.home.productCards.credits')}
            </p>
            <p className="text-sm text-neutralColor">{credits}</p>
          </div>
          <div className="flex flex-col gap-1">
            <p className="text-sm text-neutralColor60">
              {t('dashboard.home.productCards.turnaroundTime')}
            </p>
            <p className="text-sm text-neutralColor">{turnaround}</p>
          </div>
          <Button type="button" variant="secondary" rounded onClick={handleClick}>
            {buttonLabel}
          </Button>
        </div>
      </div>

      <InsufficientCreditsDialog
        open={openInsufficient}
        onOpenChange={setOpenInsufficient}
      />
    </>
  )
}
